const color = "indigo";
const style = {
  loginBtn:
    "w-full bg-indigo-500 text-white px-4 py-3  rounded hover:bg-indigo-600   mt-2 font-medium text-xs flex flex-row",
  deleteBtn:
    "bg-white text-red-500 px-4 py-2  border border-red-500 hover:text-white rounded hover:bg-red-500  mr-4 mt-2 font-medium text-xs flex flex-row",
  changeBtn:
    "w-full bg-indigo-500 text-white px-4 py-2  border border-indigo-500 hover:text-white rounded hover:bg-indigo-600  mr-4 mt-2 font-medium text-xs flex flex-row",
  cancelBtn:
    "w-full  text-gray-500 px-4 py-2  border border-gray-300 hover:text-gray-600 rounded hover:bg-gray-300  mr-4 mt-2 font-medium text-xs flex flex-row",
  LoginReguest:
    "w-full bg-gray-100 text-gray-500 px-4 py-3  border border-red-100  rounded hover:bg-red-50  mr-4 mt-2 font-medium text-xs flex flex-row",
  BackBtn:
    "w-full bg-gray-100 text-gray-500 px-4 py-3  border border-gray-100  rounded hover:bg-gray-50  mr-4 mt-2 font-medium text-xs flex flex-row",
  field: {
    parentDiv:
      "border border-indigo-200 py-3 px-3 w-full rounded flex flex-row focus-within:bg-gray-100 focus-within:border-indigo-500",
    input:
      "h-full w-full focus:outline-none text-gray-700 font-normal bg-transparent",
    icon: "m-auto ml-0 mr-1",
  },
  settingsInputs:
    "xl:flex xl:flex-row lg:flex lg:flex-row md:flex md:flex-row flex flex-col xl:w-full lg:w-full md:w-full",
};
export { color, style };
